import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import i18n from "./i18n";
import "./index.css";
import { prefetchDefaults } from "./lib/api";
import { parseRoute } from "./lib/route";

const Admin = lazy(() => import("./features/admin/Admin"));
const ProviderPage = lazy(() => import("./features/provider/ProviderPage"));
const ProviderIndex = lazy(() => import("./features/provider/ProviderIndex"));

// Path routing rather than a router library: four destinations, each a separate
// lazy chunk, and no client-side navigation between them — every link is a real
// page load, which is exactly what makes the prerendered pages worth having.
// The language lives in the path too, so `i18n` resolves it from the same parse.
const route = parseRoute(window.location.pathname);

// Start loading rates + deals before the first paint — the wizard user spends the
// whole form filling it out, and a provider page needs the same two calls.
if (route.kind !== "admin") prefetchDefaults(i18n.language);

function Root() {
  switch (route.kind) {
    case "admin":
      return <Admin />;
    case "provider":
      return <ProviderPage slug={route.slug!} />;
    case "providerIndex":
      return <ProviderIndex />;
    case "home":
      return <App />;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={null}>
      <Root />
    </Suspense>
  </StrictMode>,
);
